import React, { useState } from "react";

import * as styles from "./styles";

import { useMap } from "@cobliteam/hooks";

import { AddRounded, RemoveRounded } from "@mui/icons-material";

import { ControlButton } from "../ControlButton/ControlButton";

const MIN_ZOOM = 3;
const MAX_ZOOM = 18;

const ZoomControl = () => {
  const { mapZoom, map } = useMap();
  const [zoom, setZoom] = useState(mapZoom);

  const handleZoomIn = () => {
    setZoom(zoom + 1);
    map.zoomIn();
  };

  const handleZoomOut = () => {
    setZoom(zoom - 1);
    map.zoomOut();
  };

  return (
    <div className={`leaflet-control ${styles.zoomControl}`}>
      <ControlButton
        Icon={<AddRounded />}
        disabled={zoom === MAX_ZOOM}
        onClick={handleZoomIn}
      />
      <ControlButton
        Icon={<RemoveRounded />}
        disabled={zoom === MIN_ZOOM}
        onClick={handleZoomOut}
      />
    </div>
  );
};

export default ZoomControl;
